// extracted by mini-css-extract-plugin
module.exports = {"block":"grid_block__qA9PK","content":"grid_content__dY8bQ","element":"grid_element__137tZ"};